import { render, staticRenderFns } from "./MlbProjection.vue?vue&type=template&id=10861eb9&scoped=true"
import script from "./MlbProjection.vue?vue&type=script&lang=js"
export * from "./MlbProjection.vue?vue&type=script&lang=js"
import style0 from "./MlbProjection.vue?vue&type=style&index=0&id=10861eb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10861eb9",
  null
  
)

export default component.exports